import { LineChart, Line, CartesianGrid, XAxis, YAxis } from "recharts";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from "@/components/ui/chart";
import { CHART_COLORS } from "../utils/chartUtils";

interface LineChartViewProps {
  data: Array<Record<string, unknown>>;
  xAxis: string;
  yAxes: string[];
  config: ChartConfig;
}

/**
 * Line chart visualization for dataset query results.
 * @param props - Chart data, axis configuration, and chart config
 * @returns A line chart rendered inside a ChartContainer
 */
export default function LineChartView({
  data,
  xAxis,
  yAxes,
  config,
}: LineChartViewProps) {
  return (
    <ChartContainer config={config} className="min-h-[350px] w-full">
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-border/50" />
        <XAxis dataKey={xAxis} fontSize={11} tickLine={false} />
        <YAxis fontSize={11} tickLine={false} axisLine={false} />
        <ChartTooltip content={<ChartTooltipContent />} />
        {yAxes.map((col, i) => (
          <Line
            key={col}
            type="monotone"
            dataKey={col}
            stroke={CHART_COLORS[i % CHART_COLORS.length]}
            strokeWidth={2}
            dot={{ r: 2 }}
            activeDot={{ r: 4 }}
          />
        ))}
      </LineChart>
    </ChartContainer>
  );
}
